import { render, staticRenderFns } from "./ConfirmarFiscal.vue?vue&type=template&id=573f71f4&lang=pug&"
import script from "./ConfirmarFiscal.vue?vue&type=script&lang=js&"
export * from "./ConfirmarFiscal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports